// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".GQI0t-IconBase-module_root{display:inline-block;font-size:inherit}.GQI0t-IconBase-module_root:before{display:block}.EfsxC-IconBase-module_is-clickable{cursor:pointer}.IoNjQ-IconBase-module_color_successForeground{color:var(--successForeground)}.qhoIX-IconBase-module_color_dangerForeground{color:var(--dangerForeground)}.o9jqP-IconBase-module_color_foreground400{color:var(--foreground400)}.vbvzz-IconBase-module_color_primaryForeground{color:var(--primary-foreground)}.y6chA-IconBase-module_color_secondaryForeground{color:var(--secondary-foreground)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "GQI0t-IconBase-module_root",
	"is-clickable": "EfsxC-IconBase-module_is-clickable",
	"color_successForeground": "IoNjQ-IconBase-module_color_successForeground",
	"color_dangerForeground": "qhoIX-IconBase-module_color_dangerForeground",
	"color_foreground400": "o9jqP-IconBase-module_color_foreground400",
	"color_primaryForeground": "vbvzz-IconBase-module_color_primaryForeground",
	"color_secondaryForeground": "y6chA-IconBase-module_color_secondaryForeground"
};
export default ___CSS_LOADER_EXPORT___;
